<app-spinner *ngIf="isLoading"></app-spinner>

<div class="card" *ngIf="!isLoading">
  <div class="card-header" (click)="downloadCSV()">
    Listado de ingredientes y condimentos
    <small class="btn btn-success float-right">
      Descargar CSV para MS Excel&nbsp;&nbsp;
      <i class="fa fa-file-excel-o" aria-hidden="true"></i>
    </small>
  </div>
  <div class="card-body table-card-body">
    <div class="row">
      <div class="form-group col-sm-5">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            placeholder="Buscar por descripción"
            [(ngModel)]="filter"
            (keyup.enter)="getLength()"
          />
          <div class="input-group-append">
            <button
              class="btn btn-secondary"
              type="submit"
              (click)="getLength()"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="form-group col-sm-7">
        <button
          class="btn btn-light btn-icon"
          type="button"
          (click)="resetFilters()"
        >
          Restablecer búsqueda<i class="fa fa-eraser"></i>
        </button>
        <p *ngIf="itemsLength" class="text-muted float-right">
          <strong
            >{{ itemsLength }} elemento<span *ngIf="itemsLength > 1"
              >s</span
            ></strong
          >
        </p>
      </div>
    </div>

    <div *ngIf="!items || !items.length" class="text-center pt-3 pb-3">
      <h3>No se han encontrado ingredientes ni condimentos</h3>
      <h4 class="text-muted">Por favor, revise el filtro de búsqueda</h4>
    </div>

    <div class="table-responsive" *ngIf="items && items.length">
      <table class="table table-striped">
        <thead class="thead-dark">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Concepto</th>
            <th scope="col">Descripción</th>
            <th scope="col">Tipo</th>
            <th scope="col">Nº platos</th>
            <th scope="col">Platos asignados</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td class="text-muted">{{ item.id }}</td>
            <td class="text-muted">{{ item.concepto }}</td>
            <td>{{ item.descripcion }}</td>
            <td>{{ item.tipo }}</td>
            <td>{{ item.n_platos_asignados }}</td>
            <td [innerHTML]="item.platos_asignados"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ngb-pagination
  *ngIf="itemsLength > pageSize && !isLoading"
  class="d-flex justify-content-center"
  [(page)]="currentPage"
  (pageChange)="onPageChange($event)"
  [pageSize]="pageSize"
  [collectionSize]="itemsLength"
  [boundaryLinks]="false"
  [maxSize]="5"
  [rotate]="true"
>
</ngb-pagination>
